:host {
    --size: 150px;

    display: inline-flex;
    overflow: hidden;
    width: var(--size);
    height: var(--size);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

:host([data-state-fallback]) {
    background: var(--solid-ui-color-gray-100);
    justify-content: center;
    align-items: center;

    icon-lucide-circle-user {
        color: var(--solid-ui-color-gray-200);
        width: 50%;
        height: 50%;
    }
}
